(function() {
  var inboxLoadInterval = null;
  var maxAttempts = 50; // 50 * 200ms = 10s
  var attempts = 0;
  var loadingButtons = [];

  function tryOpenInbox() {
    // 1. Try ShopifyInbox SDK
    if (window.ShopifyInbox && typeof window.ShopifyInbox.getSDK === 'function') {
      try {
        var sdk = window.ShopifyInbox.getSDK();
        if (sdk && typeof sdk.open === 'function') {
          sdk.open();
          cleanup();
          return true;
        }
      } catch (e) { console.error(e); }
    }

    // 2. Try old ShopifyInbox.openChat
    if (window.ShopifyInbox && typeof window.ShopifyInbox.openChat === 'function') {
      try {
        window.ShopifyInbox.openChat();
        cleanup();
        return true;
      } catch (e) { console.error(e); }
    }

    // 3. Try Shadow DOM element (inbox-online-store-chat)
    var chatHost = document.querySelector('inbox-online-store-chat');
    if (chatHost && chatHost.shadowRoot) {
      var toggleBtn = chatHost.shadowRoot.querySelector('button.chat-toggle') || chatHost.shadowRoot.querySelector('button');
      if (toggleBtn) {
        try {
          toggleBtn.click();
          cleanup();
          return true;
        } catch (e) { console.error(e); }
      }
    }

    // 4. Try standard iframe or button selectors
    var chatFrame = document.querySelector('iframe#shopify-chat-button') || 
                    document.querySelector('iframe[src*="shopify-chat"]') ||
                    document.querySelector('.shopify-chat-button') ||
                    document.querySelector('#shopify-chat-button');
    if (chatFrame) {
      try {
        chatFrame.click();
        chatFrame.contentWindow?.postMessage(JSON.stringify({ type: 'shopify-chat:open' }), '*');
        chatFrame.contentWindow?.postMessage('openChat', '*');
        cleanup();
        return true;
      } catch (e) { console.error(e); }
    }

    // 5. Try broadcasting to all frames
    try {
      var frames = window.frames;
      for (var i = 0; i < frames.length; i++) {
        frames[i].postMessage(JSON.stringify({ type: 'shopify-chat:open' }), '*');
        frames[i].postMessage('openChat', '*');
      }
    } catch (e) {}

    // 6. Try ShopifyChat global
    if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
      try {
        window.ShopifyChat.open();
        cleanup();
        return true;
      } catch (e) {}
    }

    return false;
  }

  function cleanup() {
    if (inboxLoadInterval) {
      clearInterval(inboxLoadInterval);
      inboxLoadInterval = null;
    }
    loadingButtons.forEach(function(btn) {
      if (btn) btn.classList.remove('btn--loading');
    });
    loadingButtons = [];
    window.shouldOpenInboxOnLoad = false;
  }

  function pollForInbox() {
    attempts++;
    if (tryOpenInbox()) {
      return;
    }
    if (attempts >= maxAttempts) {
      cleanup();
      console.warn('Shopify Inbox could not be loaded or opened.');
    }
  }

  function startWaiting(btn) {
    if (btn && !loadingButtons.includes(btn)) {
      btn.classList.add('btn--loading');
      loadingButtons.push(btn);
    }
    window.shouldOpenInboxOnLoad = true;
    attempts = 0;
    if (!inboxLoadInterval) {
      inboxLoadInterval = setInterval(pollForInbox, 200);
    }
  }

  // Set up listeners for various initialization events
  var handleInitEvent = function() {
    if (window.shouldOpenInboxOnLoad) {
      tryOpenInbox();
    }
  };

  document.addEventListener('shopifyInboxSDKInit', handleInitEvent);
  document.addEventListener('shopify:inbox:ready', handleInitEvent);
  document.addEventListener('shopify-inbox-ready', handleInitEvent);

  // Expose openShopifyInbox globally
  window.openShopifyInbox = function(event) {
    if (event) event.preventDefault();
    var btn = event ? (event.currentTarget || event.target.closest('button') || event.target) : null;
    
    // Try to open it right away
    var opened = tryOpenInbox();
    if (!opened) {
      // Not ready yet, show loading spinner and poll/wait
      startWaiting(btn);
    }
  };
})();